import {
  createStyles,
  Theme,
  withStyles
} from "@material-ui/core/styles";
import { InputBase } from "@material-ui/core";

export const useStyles: any = (theme: Theme) => ({
    root: {
      textAlign: "center",
      maxWidth: 920,
      width: "100%"
    },
    paper: {
      height: 274
    },
    button: {
      maxWidth: 345,
      width: "100%",
      height: 55,
      backgroundColor: "#0256A8",
      marginTop: 26,
      color: "#fff",
      borderRadius: 6,
      alignSelf: "center",
      boxShadow: "none",
      "&:hover": {
        background: "#004991"
      }
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.common.white,
      border: "1px solid #ced4da",
      fontSize: 16,
      width: "auto",
      padding: "10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"])
    },
    margin: {
      width: "100%",
      maxWidth: 540,
      margin: "0 19px"
    },
    goback: {
      padding: "0 19px",
      maxWidth: 768,
    },
    groupForm: {
      backgroundColor: "#fff",
      padding: "40px 0"
    },
    form: {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    },
    inputLabel: {
      color: "#393939",
      fontSize: 16,
      fontWeight: "bold",
      '&.Mui-focused': {
        color: "#393939",
      }
    },
    notifiError: {
      alignSelf: "flex-start",
      fontSize: 14,
      marginTop: 10,
      marginBottom: 6,
      outline: "none"
    },
    labelButton: {                                                                                                   
      fontSize: 20,
      fontWeight: 'bold'
    }
  })

export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3)
      }
    },
    input: {
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: 6,
      fontSize: 22,
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      height: 47,
      padding: '0 15px'
    }
  })
)(InputBase);
